(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["card-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function updateSwatchOverflows() {
      document.querySelectorAll('.card-color-swatches').forEach(function (el) {
        var overflow = el.querySelector('.card-color-swatches__overflow');
        if (!overflow) return;

        var count;
        if (window.matchMedia('(min-width: 990px)').matches) {
          count = parseInt(el.dataset.overflowDesktop, 10);
        } else if (window.matchMedia('(min-width: 750px)').matches) {
          count = parseInt(el.dataset.overflowTablet, 10);
        } else {
          count = parseInt(el.dataset.overflowMobile, 10);
        }

        overflow.textContent = count > 0 ? '+' + count : '';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateSwatchOverflows);
    } else {
      updateSwatchOverflows();
    }

    window.addEventListener('resize', updateSwatchOverflows);
  })();
  } catch(e) { console.error(e); }
})();

})();
